import React, { useLayoutEffect } from 'react';
import styles from './style.module.scss';
import { Card, Col, Row, Table, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import Button from 'components/button';
import useBreadcrumb from 'hooks/useBreadcrumb';
import Filters from 'components/filters';
import useOrders from './useOrdersAdmin';
import OrderViewModal from 'components/orderViewModal';
import { Route, Routes } from 'react-router-dom';
import RefoundReasonModal from './refoundReasonModal';

const { TabPane } = Tabs;

const RefoundOrders = () => {
  const { t } = useTranslation();
  const { addNewBreadcrumb, removeLastBreadcrumb } = useBreadcrumb();
  const {
    filters,
    columns,
    loading,
    updateInProcess,
    data,
    onChangeTableFilter,
    handleChangeTab,
    user,
    singleItem,
    setCurrentOrderId,
    currentOrderId,
    refundedOrdersStatuses,
    handleAddProductToRefound,
    showRefoundReasonModal,
    handleCancelRefoundModal,
    handleCancelReasonModal,
    handleSubmitRefoundModal,
    handleSubmitReasonModal,
    handleChangeRefoundReason,
    refoundReason,
    ordersExportLoading,
    handleExport,
    onChangeRefundItem,
  } = useOrders();

  useLayoutEffect(() => {
    removeLastBreadcrumb('/orders/new');
    addNewBreadcrumb(t('Pratiche di reso'), '/orders/new');
    return () => {
      removeLastBreadcrumb('/orders/new');
    };
  }, []);

  const {
    refunded_orders_count,
    ask_to_refund_orders_count,
    refund_orders_count,
    waiting_for_products_refund_orders_count,
  } = data?.rest || {};

  return (
    <Card className={styles.card} title={t('Pratiche di reso')}>
      <Row>
        <Tabs
          style={{
            width: '100%',
          }}
          defaultActiveKey='1'
          onChange={handleChangeTab}
        >
          <TabPane
            tab={t('Tutte le pratiche') + ` (${refund_orders_count})`}
            key={refundedOrdersStatuses.all}
          />
          <TabPane
            tab={
              t('Pratiche in attesa di approvazione') +
              ` (${ask_to_refund_orders_count})`
            }
            key={refundedOrdersStatuses.ask_to_refund}
          />
          <TabPane
            tab={
              t('Pratiche elaborate in attesa di ricevere prodotti') +
              ` (${waiting_for_products_refund_orders_count})`
            }
            key={refundedOrdersStatuses.waiting_for_products_refund}
          />
          <TabPane
            tab={t('Pratiche chiuse') + ` (${refunded_orders_count})`}
            key={refundedOrdersStatuses.refunded}
          />
        </Tabs>
        <Col span={24}>
          <Filters filters={filters} />
          <br />
        </Col>
        <Col span={24}>
          <Button onClick={handleExport} loading={ordersExportLoading}>
            {t('Scarica excel')}
          </Button>
        </Col>
        <Col span={24}>
          <br />
          <Table
            loading={loading}
            bordered
            dataSource={data.orders}
            pagination={data.pagination}
            onChange={onChangeTableFilter}
            columns={columns}
            scroll={{ x: 2000 }}
          />
        </Col>
      </Row>
      <Routes>
        <Route
          path={'view/:id'}
          element={
            <OrderViewModal
              refound
              hideActionButtons={singleItem.status === 'refunded'}
              shop={user?.currentShop}
              loading={loading || updateInProcess}
              onClose={handleCancelRefoundModal}
              order={singleItem}
              variants={singleItem?.refund_order_product_variants}
              setCurrentOrderId={setCurrentOrderId}
              currentOrderId={currentOrderId}
              onChange={handleAddProductToRefound}
              onSubmit={handleSubmitRefoundModal}
              onChangeRefundItem={onChangeRefundItem}
            />
          }
        />
      </Routes>
      {showRefoundReasonModal && (
        <RefoundReasonModal
          onSubmit={handleSubmitReasonModal}
          onClose={handleCancelReasonModal}
          handleChangeRefoundReason={handleChangeRefoundReason}
          refoundReason={refoundReason}
          loading={updateInProcess}
        />
      )}
    </Card>
  );
};

export default RefoundOrders;
